import loadable from '@loadable/component';
import React from 'react';
import { Route, Switch } from 'react-router';

import { NotFound } from 'src/modules/notFound';
import {
  CanonicalLink as MetaCanonicalLink,
  Title as MetaTitle,
} from 'src/shared/components/Meta';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';
import { Route as Routes } from 'src/shared/route';

import { SignUpFork } from '../SignUpFork';

const Homeowner = loadable(() => import('../Homeowner'), {
  resolveComponent: module => module.Router,
});

const Professional = loadable(() => import('../Professional'), {
  resolveComponent: module => module.Router,
});

const Router = () => {
  const t = useTranslate(TranslationNamespace.SIGN_UP);

  return (
    <>
      <MetaCanonicalLink pathname={Routes.SIGN_UP.path} />
      <MetaTitle title={t('signUpForAHoverAccount')} />
      <Switch>
        <Route path={Routes.SIGN_UP_HOMEOWNER.path}>
          <Homeowner />
        </Route>
        <Route
          exact
          path={[
            Routes.SIGN_UP_PROFESSIONAL.path,
            Routes.SIGNUP_PROFESSIONAL_ACTIVATE.path,
            Routes.SIGN_UP_PROFESSIONAL_SSO.path,
            Routes.SIGN_UP_PROFESSIONAL_ORGANIZATION.path,
          ]}
        >
          <Professional />
        </Route>
        <Route exact path={Routes.SIGN_UP.path}>
          <SignUpFork />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </>
  );
};

export { Router };
